import gql from "graphql-tag";

const queryCreate = gql`
  mutation($name: String!, $description: String) {
    createPermissionPossession(data: { name: $name, description: $description }) {
      id
      name
      description
      updatedAt
      createdAt
    }
  }
`;

const queryUpdate = gql`
  mutation($id: ID!, $name: String, $description: String) {
    updatePermissionPossession(
      id: $id
      data: { name: $name, description: $description }
    ) {
      id
      name

      updatedAt
      createdAt
    }
  }
`;

const queryDelete = gql`
  mutation($id: ID!) {
    deletePermissionPossession(id: $id) {
      id
    }
  }
`;

const queryGetAll = gql`
  query {
    getAllPermissionPossession {
      id
      name
      description
      updatedAt
      createdAt
    }
  }
`;

const queryGet = gql`
  query($id: ID!) {
    getPermissionPossession(id: $id) {
      id
      name
      updatedAt
      createdAt
      description
      author {
        id
        fullname
      }
    }
  }
`;

const getListNamePermissionPossession = gql`
  query {
    getListNamePermissionPossession
  }
`;

export default {
  queryCreate,
  queryUpdate,
  queryDelete,
  queryGetAll,
  queryGet,
  getListNamePermissionPossession,
};
